// import React, { useState, useEffect } from "react";

// // Single-file React component that implements a 2-step checkout flow:
// // 1) Payment method selection (radio buttons)
// // 2) Summary page showing the stored payment method
// // The component stores the selected method in component state AND in localStorage (so it's "stored")
// // Default export is the PaymentCheckout component.

// export default function PaymentCheckout() {
//   const [step, setStep] = useState(1); // 1 = select, 2 = summary
//   const [paymentMethod, setPaymentMethod] = useState("");
//   const [error, setError] = useState("");

//   // Load saved method from localStorage when component mounts
//   useEffect(() => {
//     const saved = window.localStorage.getItem("paymentMethod");
//     if (saved) setPaymentMethod(saved);

//     // inject minimal styles so this single-file component looks nice
//     const id = "pm-styles";
//     if (!document.getElementById(id)) {
//       const style = document.createElement("style");
//       style.id = id;
//       style.innerHTML = `
//         .pm-container{max-width:680px;margin:28px auto;padding:22px;background:#fff;border-radius:12px;box-shadow:0 8px 30px rgba(2,6,23,0.08);font-family:Inter,system-ui,Arial;}
//         .pm-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:18px}
//         .pm-title{font-size:20px;font-weight:700;color:#083b4e}
//         .pm-stepper{display:flex;gap:8px}
//         .pm-step{padding:6px 10px;border-radius:8px;background:#f3fdfe;color:#036; font-weight:600}
//         .pm-card{padding:16px;border-radius:10px;border:1px solid #eef9f8;background:linear-gradient(180deg,#ffffff,#fcfffe);}
//         .pm-options{display:flex;flex-direction:column;gap:12px;margin-top:12px}
//         .pm-option{display:flex;align-items:center;gap:12px;padding:12px;border-radius:10px;border:1px solid transparent;cursor:pointer}
//         .pm-option:hover{border-color:#e0f6f5;background:#fbfffe}
//         .pm-radio{width:18px;height:18px;border-radius:50%;border:2px solid #cfdde0;display:inline-block;position:relative}
//         .pm-radio.checked{border-color:#0fb9b1}
//         .pm-radio.checked::after{content:"";position:absolute;left:4px;top:4px;width:6px;height:6px;border-radius:50%;background:#0fb9b1}
//         .pm-label{font-weight:600;color:#053b4e}
//         .pm-desc{font-size:13px;color:#5b6b6b}
//         .pm-actions{display:flex;gap:10px;margin-top:18px}
//         .btn{padding:10px 14px;border-radius:10px;border:none;cursor:pointer;font-weight:700}
//         .btn-primary{background:linear-gradient(90deg,#083b4e,#0fb9b1);color:white}
//         .btn-ghost{background:transparent;border:1px solid #dfeff0;color:#083b4e}
//         .pm-error{color:#e74c3c;margin-top:8px;font-weight:600}
//         .summary-row{display:flex;justify-content:space-between;gap:8px;padding:12px 0;border-bottom:1px dashed #eef6f5}
//         .saved-badge{display:inline-block;padding:6px 10px;background:#eefaf6;border:1px solid #d7f3ec;color:#0b6b5a;border-radius:999px;font-weight:700}
//       `;
//       document.head.appendChild(style);
//     }
//   }, []);

//   // helper to persist selection
//   function saveMethod(method) {
//     setPaymentMethod(method);
//     window.localStorage.setItem("paymentMethod", method);
//     setError("");
//   }

//   function handleNext() {
//     if (!paymentMethod) {
//       setError("Please select a payment method before proceeding.");
//       return;
//     }
//     setError("");
//     setStep(2);
//   }

//   function handleSelect(method) {
//     saveMethod(method);
//   }

//   function handleEdit() {
//     setStep(1);
//   }

//   // UI pieces for options
//   const Option = ({ id, label, desc }) => {
//     const checked = paymentMethod === id;
//     return (
//       <div
//         className="pm-option"
//         role="button"
//         onClick={() => handleSelect(id)}
//         onKeyDown={(e) => e.key === "Enter" && handleSelect(id)}
//         tabIndex={0}
//       >
//         <div className={"pm-radio " + (checked ? "checked" : "")}></div>
//         <div>
//           <div className="pm-label">{label}</div>
//           <div className="pm-desc">{desc}</div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="pm-container">
//       <div className="pm-header">
//         <div className="pm-title">Checkout — Payment</div>
//         <div className="pm-stepper">
//           <div className="pm-step">1. Payment</div>
//           <div className="pm-step">2. Summary</div>
//         </div>
//       </div>

//       {step === 1 && (
//         <div className="pm-card">
//           <div style={{fontSize:14,color:'#113'}}>
//             Choose a payment method. Your choice will be saved locally and shown on the summary page.
//           </div>

//           <div className="pm-options">
//             <Option id="COD" label="Cash on Delivery" desc="Pay with cash when your order arrives." />
//             <Option id="UPI" label="UPI" desc="Pay instantly using any UPI app (PhonePe, Google Pay, Paytm etc.)." />
//             <Option id="CARD" label="Debit / Credit Card" desc="Pay with Visa, Mastercard, or RuPay cards." />
//           </div>

//           {error && <div className="pm-error">{error}</div>}

//           <div className="pm-actions">
//             <button className="btn btn-primary" onClick={handleNext}>Continue to Summary</button>
//             <button className="btn btn-ghost" onClick={() => { saveMethod(''); setError(''); }}>Clear Selection</button>
//           </div>

//         </div>
//       )}

//       {step === 2 && (
//         <div className="pm-card">
//           <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
//             <div style={{fontWeight:700}}>Order Summary</div>
//             <div className="saved-badge">Saved</div>
//           </div>

//           <div className="summary-row">
//             <div>Items</div>
//             <div>3</div>
//           </div>

//           <div className="summary-row">
//             <div>Subtotal</div>
//             <div>₹1,200</div>
//           </div>

//           <div className="summary-row">
//             <div>Payment Method</div>
//             <div style={{fontWeight:700}}>{paymentMethod || '—'}</div>
//           </div>

//           <div style={{marginTop:16,display:'flex',gap:10}}>
//             <button className="btn btn-primary" onClick={() => alert('Order placed! (demo)')}>Place Order</button>
//             <button className="btn btn-ghost" onClick={handleEdit}>Edit Payment</button>
//           </div>

//         </div>
//       )}

//     </div>
//   );
// }
























import React, { useState, useEffect } from "react";

export default function PaymentCheckout() {
  const [step, setStep] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const saved = window.localStorage.getItem("paymentMethod");
    if (saved) setPaymentMethod(saved);

    // Inject enhanced styles
    const id = "pm-styles";
    if (!document.getElementById(id)) {
      const style = document.createElement("style");
      style.id = id;
      style.innerHTML = `
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');

        body {
          background: linear-gradient(135deg, #0fb9b1, #15099fff, #0fb9b1);
          background-size: 400% 400%;
          animation: gradientFlow 10s ease infinite;
          font-family: 'Poppins', sans-serif;
        }

        @keyframes gradientFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .pm-container {
          max-width: 720px;
          margin: 40px auto;
          padding: 35px;
          border-radius: 20px;
          background: rgba(255, 255, 255, 0.15);
          box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
          backdrop-filter: blur(10px);
          color: #fff;
          transition: all 0.3s ease;
        }

        .pm-container:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 50px rgba(0, 0, 0, 0.35);
        }

        .pm-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
        }

        .pm-title {
          font-size: 22px;
          font-weight: 700;
          color: #fff;
        }

        .pm-stepper {
          display: flex;
          gap: 8px;
        }

        .pm-step {
          padding: 6px 12px;
          border-radius: 8px;
          background: rgba(255,255,255,0.15);
          color: #d7fdfd;
          font-weight: 600;
          box-shadow: inset 0 0 10px rgba(255,255,255,0.15);
        }

        .pm-card {
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255,255,255,0.25);
          padding: 25px;
          border-radius: 16px;
          color: #fff;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .pm-card:hover {
          transform: scale(1.01);
          box-shadow: 0 0 25px rgba(15, 185, 177, 0.3);
        }

        .pm-options {
          display: flex;
          flex-direction: column;
          gap: 14px;
          margin-top: 18px;
        }

        .pm-option {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 16px;
          border-radius: 12px;
          background: rgba(255,255,255,0.12);
          border: 1.5px solid transparent;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .pm-option:hover {
          border-color: #0fb9b1;
          background: rgba(255,255,255,0.22);
          transform: scale(1.02);
        }

        .pm-radio {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 2px solid #ccc;
          position: relative;
        }

        .pm-radio.checked {
          border-color: #0fb9b1;
        }

        .pm-radio.checked::after {
          content: "";
          position: absolute;
          left: 4px;
          top: 4px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #0fb9b1;
          box-shadow: 0 0 10px #0fb9b1;
        }

        .pm-label {
          font-weight: 600;
          font-size: 15px;
        }

        .pm-desc {
          font-size: 13px;
          color: #d0f4f2;
        }

        .pm-actions {
          display: flex;
          gap: 12px;
          margin-top: 22px;
        }

        .btn {
          padding: 12px 18px;
          border-radius: 12px;
          border: none;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .btn-primary {
          background: linear-gradient(90deg, #083b4e, #0fb9b1);
          color: #fff;
          box-shadow: 0 4px 15px rgba(15,185,177,0.3);
        }

        .btn-primary:hover {
          background: linear-gradient(90deg, #0fb9b1, #083b4e);
          box-shadow: 0 0 20px rgba(15,185,177,0.6);
          transform: translateY(-2px);
        }

        .btn-ghost {
          background: transparent;
          border: 1px solid rgba(255,255,255,0.3);
          color: #fff;
        }

        .btn-ghost:hover {
          background: rgba(255,255,255,0.2);
          border-color: #0fb9b1;
        }

        .pm-error {
          color: #ff6b6b;
          margin-top: 10px;
          font-weight: 600;
          background: rgba(255,0,0,0.1);
          border-radius: 8px;
          padding: 6px 8px;
          text-align: center;
        }

        .summary-row {
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px dashed rgba(255,255,255,0.3);
          font-size: 15px;
        }

        .saved-badge {
          background: rgba(15,185,177,0.3);
          color: #fff;
          border-radius: 999px;
          padding: 6px 12px;
          font-weight: 700;
          font-size: 13px;
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  function saveMethod(method) {
    setPaymentMethod(method);
    window.localStorage.setItem("paymentMethod", method);
    setError("");
  }

  function handleNext() {
    if (!paymentMethod) {
      setError("⚠ Please select a payment method before continuing.");
      return;
    }
    setError("");
    setStep(2);
  }

  function handleSelect(method) {
    saveMethod(method);
  }

  function handleEdit() {
    setStep(1);
  }

  const Option = ({ id, label, desc }) => {
    const checked = paymentMethod === id;
    return (
      <div
        className="pm-option"
        role="button"
        onClick={() => handleSelect(id)}
        onKeyDown={(e) => e.key === "Enter" && handleSelect(id)}
        tabIndex={0}
      >
        <div className={`pm-radio ${checked ? "checked" : ""}`}></div>
        <div>
          <div className="pm-label">{label}</div>
          <div className="pm-desc">{desc}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="pm-container">
      <div className="pm-header">
        <div className="pm-title">💳 Checkout — Payment</div>
        <div className="pm-stepper">
          <div className="pm-step">1. Payment</div>
          <div className="pm-step">2. Summary</div>
        </div>
      </div>

      {step === 1 && (
        <div className="pm-card">
          <div style={{ fontSize: 14, color: "#e0ffff" }}>
            Choose your preferred payment method. Your choice will be saved and shown on the summary page.
          </div>

          <div className="pm-options">
            <Option id="COD" label="💵 Cash on Delivery" desc="Pay with cash when your order arrives." />
            <Option id="UPI" label="📱 UPI" desc="Pay instantly via PhonePe, GPay, Paytm, etc." />
            <Option id="CARD" label="💳 Debit / Credit Card" desc="Pay with Visa, Mastercard, or RuPay cards." />
          </div>

          {error && <div className="pm-error">{error}</div>}

          <div className="pm-actions">
            <button className="btn btn-primary" onClick={handleNext}>
              Continue to Summary →
            </button>
            <button
              className="btn btn-ghost"
              onClick={() => {
                saveMethod("");
                setError("");
              }}
            >
              Clear
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="pm-card">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 18 }}>🧾 Order Summary</div>
            <div className="saved-badge">Saved</div>
          </div>

          <div className="summary-row">
            <div>Items</div>
            <div>3</div>
          </div>

          <div className="summary-row">
            <div>Subtotal</div>
            <div>₹1,200</div>
          </div>

          <div className="summary-row">
            <div>Payment Method</div>
            <div style={{ fontWeight: 700 }}>
              {paymentMethod || "—"}
            </div>
          </div>

          <div style={{ marginTop: 16, display: "flex", gap: 10 }}>
            <button
              className="btn btn-primary"
              onClick={() => alert("✅ Order placed successfully! (Demo)")}
            >
              Place Order
            </button>
            <button className="btn btn-ghost" onClick={handleEdit}>
              Edit Payment
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
